import { formatDate, FormatDateType } from '../../../../helpers/date';
import { ClickableAction } from '../../Clickable/consts';
import {
    HeadlineAlign,
    HeadlineColor,
    HeadlineLevel,
} from '../../Headline/consts';
import Headline from '../../Headline/Headline';
import Icon from '../../Icon/Icon';
import Image from '../../Image/Image';
import Share from '../../Share/Share';
import PressHr from '../PressHr/PressHr';
import PressImage from '../PressImage/PressImage';
import { PressHeaderProps } from './interfaces';
import styles from './PressHeader.module.scss';

const PressHeader = ({
  date,
  tag,
  tags,
  headline,
  children,
  shareData,
  asset,
  imageCaption,
  assetDownloadLink,
  backButtonPath,
}: PressHeaderProps) => {
  const prettyDate = (
    <span>
      {!date || date === 'undefined'
        ? 'Datum nicht gesetzt'
        : formatDate(new Date(date), FormatDateType.PressArticle)}
    </span>
  );

  const prettyTag = tag && <span className={styles.infoMainTag}>{tag}</span>;
  const prettyTagList = tags?.map((tagName) => (
    <span key={tagName} className={styles.infoTag}>
      {tagName}
    </span>
  ));
  const info = [prettyDate, prettyTag, prettyTagList].filter(Boolean);
  return (
    <div className={styles.base}>
      <h4 className={styles.info}>{info}</h4>
      <Headline
        headlineColor={HeadlineColor.Gradient}
        level={HeadlineLevel.One}
        tag="h1"
        align={HeadlineAlign.Left}
        className={styles.headline}
      >
        {headline}
      </Headline>
      <div className={styles.bar}>
        <a className={styles.backButton} href={backButtonPath}>
          <Icon
            variant={'action/arrow-left'}
            size="iconSize24"
            className={styles.icon}
          />{' '}
          Zurück zur Übersicht
        </a>
        {shareData && <Share {...shareData} />}
      </div>

      {children && (
        <>
          <PressHr />
          <div className={styles.list}>{children}</div>
        </>
      )}
      {asset &&
        (!assetDownloadLink ? (
          <Image
            className={styles.image}
            image={asset}
            actionType={ClickableAction.None}
            fitCover
            caption={imageCaption}
          />
        ) : (
          <PressImage
            image={asset}
            assetLink={assetDownloadLink}
            actionType={ClickableAction.None}
            fitCover
            caption={imageCaption}
          />
        ))}
    </div>
  );
};

export default PressHeader;
